import type { ResolverInput, ResolverResult } from './types';

// §1.1: migrated to RPC. has_tax checks businesses.tax_mode — 'exempt' is
// complete without a rate, 'charge' requires hst_rate > 0 or
// invoice_settings.tax_rate > 0.
export async function resolveTaxItem(
  { progress }: ResolverInput,
): Promise<ResolverResult> {
  if (progress.has_tax) return { complete: true, reason: 'tax configured' };
  return { complete: false, reason: 'tax not configured' };
}
